import React from 'react'

const AnalyticsDataLeftSkeleton = () => {
    return (
        <div className="w-full h-full rounded-[10px] bg-white flex flex-col max-w-[479px] animate-pulse p-[20px]">
            {/* Header section */}
            <div className="flex items-center mt-5 mx-[20px]">
                <div className="font-bold text-[20px] mr-[5px] text-darkPurple animate-pulse">
                    <div className="h-6 bg-lightBG rounded w-[100px] opacity-50"></div>
                </div>
                <div className="flex-1"></div>
                <div className="w-[20px] h-[20px] bg-lightBG rounded opacity-50"></div>
                <div className="ml-[10px] font-bold text-[16px] text-mudPurple animate-pulse">
                    <div className="h-5 bg-lightBG rounded w-[56px] opacity-50"></div>
                </div>
            </div>

            {/* Search bar */}
            <div className="mt-[10px] mx-[20px]">
                <div className="h-10 bg-lightBG rounded w-full opacity-50"></div>
            </div>

            {/* Divider */}
            <div className="mt-5 mx-[20px] h-[1px] border-b border-dashed border-b-lightBG"></div>

            {/* Info text */}
            <div className="mt-4 mx-[20px]">
                <div className="h-4 bg-lightBG rounded w-[70%] opacity-50"></div>
            </div>

            {/* Content list skeleton */}
            <div className="flex flex-col flex-auto mx-[10px] bg-white mt-4 pr-[10px]">
                {[...Array(4)].map((_, idx) => (
                    <div key={idx} className="flex flex-col p-6 border-b border-lightBG animate-pulse">
                        <div className="flex justify-between items-center mb-2">
                            <div className="h-5 bg-lightBG rounded w-[60%] opacity-50"></div>
                            <div className="w-[40px] h-[40px] bg-[#FDDF6D] rounded-full opacity-40"></div>
                        </div>
                        <div className="h-4 bg-lightBG rounded w-[40%] opacity-30 mb-4"></div>
                        <div className="flex gap-2 items-center">
                            <div className="w-[30px] h-[30px] rounded-full bg-lightBG opacity-50"></div>
                            <div className="h-4 bg-lightBG rounded w-[120px] opacity-30"></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AnalyticsDataLeftSkeleton
